const freeGiftHandleElement1 = document.querySelector('div[data-free-gift-handle-1]');
const freeGiftHandle1 = freeGiftHandleElement1 ? freeGiftHandleElement1.getAttribute('data-free-gift-handle-1') : null;

const freeGiftHandleElement2 = document.querySelector('div[data-free-gift-handle-2]');
const freeGiftHandle2 = freeGiftHandleElement2 ? freeGiftHandleElement2.getAttribute('data-free-gift-handle-2') : null;

const freeGiftEnabledElement = document.querySelector('div[data-free-gift-enabled]');
const freeGiftEnabled = freeGiftEnabledElement ? freeGiftEnabledElement.getAttribute('data-free-gift-enabled') === 'true' : false;

const freeGiftThresholdElement = document.querySelector('div[data-free-gift-threshold]');
const freeGiftThreshold = freeGiftThresholdElement ? parseInt(freeGiftThresholdElement.getAttribute('data-free-gift-threshold'), 10) : null;

const thresholdInCents = freeGiftThreshold * 100;

class CartRemoveButton extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('click', (event) => {
            event.preventDefault();
            const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
            cartItems.updateQuantity(this.dataset.index, 0);

            cartItems.dispatchEvent(new CustomEvent('checkCartThreshold', { bubbles: true }));
        });
    }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
    constructor() {
        super();
        this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

        const debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));

        const variantDropdowns = document.querySelectorAll('.variant-dropdown');
        variantDropdowns.forEach((variantDropdown) => {
            variantDropdown.addEventListener('change', () => {
                this.handleVariantChange(variantDropdown);
            });
        });

        this.filterRecommendationProducts();

        this.addEventListener('checkCartThreshold', () => this.checkThresholdAndRemoveFreeGift());
    }

    cartUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'cart-items') {
                return;
            }
            this.onCartUpdate();
        });

        document.addEventListener('cartItemAdded', () => this.onCartUpdate());
    }

    disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }

        document.removeEventListener('cartItemAdded', () => this.onCartUpdate());
    }

    onChange(event) {
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }

    onCartUpdate() {
        fetch(`${routes.cart_url}`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const sourceQty = html.querySelector('cart-items');
                this.innerHTML = sourceQty.innerHTML;
                console.log('cart update check 1');

                this.refreshCartUI();
                this.checkThresholdAndRemoveFreeGift();
            })
            .catch((e) => {
                console.error(e);
            });
    }

    checkThresholdAndRemoveFreeGift() {
        console.log('checkThresholdAndRemoveFreeGift check 1');

        fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
                console.log('isEmpty', cart.item_count);

                // Always update empty state classes regardless of free gift settings
                const isEmpty = cart.item_count === 0;
                const cartDrawerWrapper = document.querySelector('cart-drawer');
                const cartDrawerItems = document.querySelector('cart-drawer-items');

                // For cart drawer elements, only add is-empty class if cart is actually empty
                // Don't remove is-empty class here - let the cart opening logic handle that
                if (isEmpty) {
                    if (cartDrawerWrapper) cartDrawerWrapper.classList.add('is-empty');
                    if (cartDrawerItems) cartDrawerItems.classList.add('is-empty');
                }
                // Note: We don't remove is-empty class here when !isEmpty
                // This is handled by removeEmptyClassAndOpenDrawer() right before opening

                // Only run free gift logic if enabled
                if (!freeGiftEnabled) {
                    console.log('Free gift feature is not enabled.');
                    return;
                }

                console.log('checkThresholdAndRemoveFreeGift check');

                const threshold = thresholdInCents;
                const isFreeGiftHandle1InCart = cart.items.some((item) => item.handle === freeGiftHandle1);
                const isFreeGiftHandle2InCart = cart.items.some((item) => item.handle === freeGiftHandle2);

                if (cart.total_price < threshold && (isFreeGiftHandle1InCart || isFreeGiftHandle2InCart)) {
                    // Remove the free gift from the cart based on user selection
                    let handleToRemove = isFreeGiftHandle1InCart ? freeGiftHandle1 : freeGiftHandle2;
                    this.removeProductFromCartByHandle(handleToRemove).then(() => {
                        // Refresh the cart UI after successful removal
                        this.refreshCartUI();
                    });
                }
            })
            .catch((error) => console.error('Failed to fetch cart:', error));
    }

    //Depricated
    // checkCartTotalAndAddOrRemoveFreeGift() {
    //   if (!freeGiftEnabled) {
    //     console.log("Free gift feature is not enabled.");
    //     return;
    //   }

    //   fetch('/cart.js')
    //     .then(response => response.json())
    //     .then(cart => {
    //       const threshold = thresholdInCents;
    //       const isFreeGiftInCart = cart.items.some(item => item.handle === freeGiftHandle);
    //       if (cart.total_price >= threshold && !isFreeGiftInCart) {
    //         this.addProductToCartByHandle(freeGiftHandle).then(() => {

    //             this.refreshCartUI();

    //         });
    //       } else if (cart.total_price < threshold && isFreeGiftInCart) {
    //         this.removeProductFromCartByHandle(freeGiftHandle).then(() => {

    //             this.refreshCartUI();

    //         });
    //       }
    //     })
    //     .catch(error => console.error('Failed to fetch cart:', error));
    // }

    // addProductToCartByHandle(productHandle) {
    //   return fetch(`/products/${productHandle}.js`)
    //     .then(response => response.json())
    //     .then(productData => {
    //       const variantId = productData.variants[0].id;
    //       return fetch('/cart/add.js', {
    //         method: 'POST',
    //         headers: {
    //           'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify({
    //           items: [{
    //             id: variantId,
    //             quantity: 1
    //           }]
    //         })
    //       });
    //     });
    // }

    removeProductFromCartByHandle(productHandle) {
        console.log('removeProductFromCartByHandle', productHandle);
        fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
                const lineItem = cart.items.find((item) => item.handle === productHandle);
                if (!lineItem) {
                    throw new Error('Product not found in cart');
                }

                const line = cart.items.indexOf(lineItem) + 1;
                if (line === 0) {
                    throw new Error('Line item not found');
                }

                const body = JSON.stringify({
                    line,
                    quantity: 0,
                    sections: this.getSectionsToRender().map((section) => section.section),
                    sections_url: window.location.pathname,
                });

                return fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: body,
                })
                    .then((response) => response.json())
                    .then(() => {
                        this.refreshCartUI();
                    });
            })
            .catch((error) => console.error('Error removing product from cart:', error));
    }

    refreshCartUI() {
        return fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
                const cartItems = cart.items;
                return fetch(`${routes.cart_url}?section_id=cart-drawer`)
                    .then((response) => response.text())
                    .then((text) => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(text, 'text/html');

                        const newCartContent = doc.querySelector('#CartDrawer').innerHTML;
                        document.querySelector('#CartDrawer').innerHTML = newCartContent;

                        const cartDrawer = document.querySelector('#CartDrawer');

                        cartItems.forEach((item, index) => {
                            const cartItemElements = cartDrawer.getElementsByClassName('cart-item');
                            if (cartItemElements[index]) {
                                cartItemElements[index].setAttribute('data-product-handle', item.handle);
                            }
                        });

                        Array.from(cartDrawer.getElementsByClassName('cart-item')).forEach((item) => {
                            if (item.getAttribute('data-product-handle') === freeGiftHandle1 || item.getAttribute('data-product-handle') === freeGiftHandle2) {
                                const removeButton = item.querySelector('.cart-remove-button');
                                if (removeButton) {
                                    removeButton.style.display = 'none';
                                }

                                const quantityWrapper = item.querySelector('.cart-item__quantity-wrapper');
                                if (quantityWrapper) {
                                    quantityWrapper.parentNode.removeChild(quantityWrapper);
                                }

                                const productNameElement = item.querySelector('.cart-item__name.h4.break');
                                if (productNameElement) {
                                    const freeGiftLabel = document.createElement('span');
                                    freeGiftLabel.textContent = 'Free Gift';
                                    freeGiftLabel.style.fontWeight = 'normal';
                                    productNameElement.parentNode.insertBefore(freeGiftLabel, productNameElement.nextSibling);
                                }

                                const priceElements = item.querySelectorAll('.product-price, .cart-item__price-wrapper');
                                priceElements.forEach((priceElement) => {
                                    priceElement.innerHTML = `<span style="text-decoration: line-through;">${priceElement.innerHTML}</span> $0`;
                                });
                            }
                        });

                        const cartDrawerWrapper = document.querySelector('cart-drawer');
                        const cartFooter = document.getElementById('main-cart-footer');
                        const cartDrawerItems = document.querySelector('cart-drawer-items');

                        const isEmpty = cart.item_count === 0;

                        // Always update footer and other elements normally
                        if (cartFooter) cartFooter.classList.toggle('is-empty', isEmpty);

                        // For cart drawer elements, only add is-empty class if cart is actually empty
                        // Don't remove is-empty class here - let the cart opening logic handle that
                        if (isEmpty) {
                            cartDrawerWrapper.classList.add('is-empty');
                            if (cartDrawerItems) cartDrawerItems.classList.add('is-empty');
                        }
                        // Note: We don't remove is-empty class here when !isEmpty
                        // This is handled by removeEmptyClassAndOpenDrawer() right before opening

                        if (!isEmpty) {
                            const firstItemName = cartDrawerWrapper.querySelector('.cart-item__name');
                            if (firstItemName) firstItemName.focus();
                        }

                        // Filter recommendations after cart update
                        this.filterRecommendationProducts();

                        cartDrawerWrapper.dispatchEvent(new CustomEvent('cartUpdated', { bubbles: true }));

                        this.updateCartNotification();
                        return Promise.resolve(); // Return a resolved promise to allow chaining
                    })
                    .catch((error) => {
                        console.error('Error updating cart UI:', error);
                        return Promise.reject(error); // Return a rejected promise to allow chaining
                    });
            })
            .catch((error) => {
                console.error('Failed to fetch cart:', error);
                return Promise.reject(error); // Return a rejected promise to allow chaining
            });
    }

    updateCartNotification() {
        const sectionsToUpdate = this.getSectionsToRenderCartNotification();
        sectionsToUpdate.forEach((section) => {
            fetch(`${routes.cart_url}?section_id=${section.id}`)
                .then((response) => response.text())
                .then((html) => {
                    const sectionElement = document.getElementById(section.id);
                    if (sectionElement) {
                        sectionElement.innerHTML = html;
                    }
                })
                .catch((error) => console.error(`Error updating section ${section.id}:`, error));
        });
    }

    getSectionsToRenderCartNotification() {
        return [
            {
                id: 'cart-notification-product',
            },
            {
                id: 'cart-notification-button',
            },
            {
                id: 'cart-icon-bubble',
            },
        ];
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section',
            },
            {
                id: 'cart-live-region-text',
                section: 'cart-live-region-text',
                selector: '.shopify-section',
            },
            {
                id: 'main-cart-footer',
                section: document.getElementById('main-cart-footer').dataset.id,
                selector: '.js-contents',
            },
        ];
    }

    updateQuantity(line, quantity, name) {
        this.enableLoading(line);
        // Removed redundant refreshCartUI() call here - will refresh after API call
        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);

                if (parsedState.errors) {
                    const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
                    if (quantityElement) {
                        quantityElement.value = quantityElement.getAttribute('value');
                        this.updateLiveRegions(line, parsedState.errors);
                    }
                    this.disableLoading(line);
                    return;
                }

                // Refresh the cart UI which handles all DOM updates
                this.refreshCartUI()
                    .then(() => {
                        // Only disable loading after cart UI refresh is complete
                        this.disableLoading(line);

                        // Check threshold after UI is refreshed
                        this.checkThresholdAndRemoveFreeGift();

                        // Update empty state classes
                        this.classList.toggle('is-empty', parsedState.item_count === 0);
                        const cartDrawerWrapper = document.querySelector('cart-drawer');
                        const cartFooter = document.getElementById('main-cart-footer');
                        const cartFooterWrapper = document.querySelector('.cart__footer-wrapper');

                        const isEmpty = parsedState.item_count === 0;

                        // Always update footer and other elements normally
                        if (cartFooter) cartFooter.classList.toggle('is-empty', isEmpty);
                        if (cartFooterWrapper) cartFooterWrapper.classList.toggle('is-empty', isEmpty);

                        // For cart drawer wrapper, only add is-empty class if cart is actually empty
                        // Don't remove is-empty class here - let the cart opening logic handle that
                        if (isEmpty && cartDrawerWrapper) {
                            cartDrawerWrapper.classList.add('is-empty');
                        }

                        // Publish cart update event
                        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
                    })
                    .catch((error) => {
                        console.error('Error updating cart UI:', error);
                        this.disableLoading(line);
                    });
            })
            .catch(() => {
                this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
                const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
                if (errors) {
                    errors.textContent = window.cartStrings.error;
                }
                this.disableLoading(line);
            });
    }

    updateLiveRegions(line, message) {
        const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
        if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

        this.lineItemStatusElement.setAttribute('aria-hidden', true);

        const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
        cartStatus.setAttribute('aria-hidden', false);

        setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    enableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.add('cart__items--disabled');

        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

        [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.remove('cart__items--disabled');

        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

        cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
        cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }

    handleVariantChange(variantDropdown) {
        const selectedVariantId = variantDropdown.value;
        const productHandle = variantDropdown.dataset.productHandle;

        fetch(`/products/${productHandle}.js`)
            .then((response) => response.json())
            .then((productData) => {
                const selectedVariant = productData.variants.find((variant) => variant.id == selectedVariantId);
                if (selectedVariant) {
                    const parentElement = variantDropdown.parentElement;
                    const priceElements = parentElement.closest('.cart_card_information').querySelectorAll('.price-item');
                    const formattedPrice = this.formatPrice(selectedVariant.price / 100, Shopify.currency.active);

                    priceElements.forEach((priceElement) => {
                        priceElement.textContent = formattedPrice;
                    });

                    const cardInfo = parentElement.closest('.cart_card_information');
                    const cardInfoParent = cardInfo.parentElement;
                    const form = cardInfoParent.querySelector('form');

                    if (form) {
                        const variantIdInput = form.querySelector('input[name="id"]');
                        if (variantIdInput) {
                            variantIdInput.value = selectedVariantId;
                            variantIdInput.disabled = false;
                        }
                    }
                }
            })
            .catch((error) => console.error('Error fetching product data:', error));
    }

    formatPrice(price, currency) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(price);
    }

    filterRecommendationProducts() {
        const cartItemHandles = [];

        // Get all product handles currently in cart
        const cartItems = document.querySelectorAll('#CartDrawer-CartItems .cart-item[data-product-handle]');
        cartItems.forEach(function (cartItem) {
            const productHandle = cartItem.getAttribute('data-product-handle');
            if (productHandle) {
                cartItemHandles.push(productHandle);
            }
        });

        // Hide recommendation wrappers for products that are in the cart
        const recommendationWrappers = document.querySelectorAll('.recommendation-wrapper[data-product-handle]');
        recommendationWrappers.forEach(function (recommendationWrapper) {
            const productHandle = recommendationWrapper.getAttribute('data-product-handle');
            if (productHandle && cartItemHandles.includes(productHandle)) {
                // Hide the parent swiper slide
                const swiperSlide = recommendationWrapper.closest('.swiper-slide');
                if (swiperSlide) {
                    swiperSlide.style.display = 'none';
                } else {
                    recommendationWrapper.style.display = 'none';
                }
            } else {
                // Show the parent swiper slide
                const swiperSlide = recommendationWrapper.closest('.swiper-slide');
                if (swiperSlide) {
                    swiperSlide.style.display = '';
                } else {
                    recommendationWrapper.style.display = '';
                }
            }
        });

        // Update swiper after filtering
        setTimeout(() => {
            const swiper = document.querySelector('#cart-recommendations-swiper');
            if (swiper && swiper.swiper) {
                swiper.swiper.update();
            }
        }, 100);
    }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
    customElements.define(
        'cart-note',
        class CartNote extends HTMLElement {
            constructor() {
                super();

                this.addEventListener(
                    'change',
                    debounce((event) => {
                        const body = JSON.stringify({ note: event.target.value });
                        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
                    }, ON_CHANGE_DEBOUNCE_TIMER),
                );
            }
        },
    );
}

document.addEventListener('DOMContentLoaded', function () {
    this.filterRecommendationProducts();
});

document.addEventListener(
    'octane.quiz.addToCart',
    function (e) {
        const items = e.detail.items;
        if (!items || items.length === 0) {
            console.error('No items provided to add to cart.');
            return;
        }

        const cartDrawerElement = document.querySelector('cart-drawer');
        const itemsToAdd = items.map((item) => ({ id: item.id, quantity: item.quantity }));

        addItemBulkToCart(itemsToAdd)
            .then(() => {
                refreshCartDrawer();
                // Wait for UI refresh, then open cart drawer (cartUpdated event will handle opening)
                // No need to manually open here as cartUpdated event listener will handle it
            })
            .catch((error) => {
                console.error('Error adding items to cart:', error);
            });
    },
    false,
);

function addItemBulkToCart(items) {
    return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            items: items,
        }),
    })
        .then((response) => response.json())
        .then((data) => {
            if (!data.errors) {
                return Promise.resolve();
            } else {
                return Promise.reject(data.message || 'An error occurred.');
            }
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

function refreshCartDrawer() {
    fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
            const cartItems = cart.items;
            fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then((response) => response.text())
                .then((text) => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(text, 'text/html');

                    const newCartContent = doc.querySelector('#CartDrawer').innerHTML;
                    document.querySelector('#CartDrawer').innerHTML = newCartContent;

                    const cartDrawer = document.querySelector('#CartDrawer');

                    cartItems.forEach((item, index) => {
                        const cartItemElements = cartDrawer.getElementsByClassName('cart-item');
                        if (cartItemElements[index]) {
                            cartItemElements[index].setAttribute('data-product-handle', item.handle);
                        }
                    });

                    Array.from(cartDrawer.getElementsByClassName('cart-item')).forEach((item) => {
                        if (item.getAttribute('data-product-handle') === freeGiftHandle1 || item.getAttribute('data-product-handle') === freeGiftHandle2) {
                            const removeButton = item.querySelector('.cart-remove-button');
                            if (removeButton) {
                                removeButton.style.display = 'none';
                            }

                            const productNameElement = item.querySelector('.cart-item__name.h4.break');
                            if (productNameElement) {
                                const freeGiftLabel = document.createElement('span');
                                freeGiftLabel.textContent = 'Free Gift';
                                freeGiftLabel.style.fontWeight = 'normal';
                                productNameElement.parentNode.insertBefore(freeGiftLabel, productNameElement.nextSibling);
                            }

                            const priceElements = item.querySelectorAll('.product-price, .cart-item__price-wrapper');
                            priceElements.forEach((priceElement) => {
                                priceElement.innerHTML = `<span style="text-decoration: line-through;">${priceElement.innerHTML}</span> $0`;
                            });

                            const quantityWrapper = item.querySelector('.cart-item__quantity-wrapper');
                            if (quantityWrapper) {
                                quantityWrapper.parentNode.removeChild(quantityWrapper);
                            }
                        }
                    });

                    const cartDrawerWrapper = document.querySelector('cart-drawer');
                    const cartFooter = document.getElementById('main-cart-footer');
                    const cartDrawerItems = document.querySelector('cart-drawer-items');

                    const isEmpty = cart.item_count === 0;
                    console.log('isEmpty', isEmpty, cart.item_count);

                    // Always update footer normally
                    if (cartFooter) cartFooter.classList.toggle('is-empty', isEmpty);

                    // For cart drawer elements, only add is-empty class if cart is actually empty
                    // Don't remove is-empty class here - let the cart opening logic handle that
                    if (isEmpty) {
                        cartDrawerWrapper.classList.add('is-empty');
                        if (cartDrawerItems) cartDrawerItems.classList.add('is-empty');
                    }

                    if (!isEmpty) {
                        const firstItemName = cartDrawerWrapper.querySelector('.cart-item__name');
                        if (firstItemName) firstItemName.focus();
                    }

                    // Filter recommendations after cart update
                    const cartItemsInstance = document.querySelector('cart-drawer-items');
                    if (cartItemsInstance && cartItemsInstance.filterRecommendationProducts) {
                        cartItemsInstance.filterRecommendationProducts();
                    }

                    cartDrawerWrapper.dispatchEvent(new CustomEvent('cartUpdated', { bubbles: true }));

                    updateCartDrawerNotification();
                })
                .catch((error) => console.error('Error updating cart UI:', error));
        })
        .catch((error) => console.error('Failed to fetch cart:', error));
}

function updateCartDrawerNotification() {
    const sectionsToUpdate = getSectionsToRenderCartDrawerNotification();
    sectionsToUpdate.forEach((section) => {
        fetch(`${routes.cart_url}?section_id=${section.id}`)
            .then((response) => response.text())
            .then((html) => {
                const sectionElement = document.getElementById(section.id);
                if (sectionElement) {
                    sectionElement.innerHTML = html;
                }
            })
            .catch((error) => console.error(`Error updating section ${section.id}:`, error));
    });
}

function getSectionsToRenderCartDrawerNotification() {
    return [
        {
            id: 'cart-notification-product',
        },
        {
            id: 'cart-notification-button',
        },
        {
            id: 'cart-icon-bubble',
        },
    ];
}

function checkCartDrawerTotalAndAddOrRemoveFreeGift() {
    console.log('checkCartDrawerTotalAndAddOrRemoveFreeGift check ');
    if (!freeGiftEnabled) {
        console.log('Free gift feature is not enabled.');
        return;
    }

    console.log('checkThresholdAndRemoveFreeGift check');

    fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
            const threshold = thresholdInCents;
            const isFreeGiftHandle1InCart = cart.items.some((item) => item.handle === freeGiftHandle1);
            const isFreeGiftHandle2InCart = cart.items.some((item) => item.handle === freeGiftHandle2);

            if (cart.total_price < threshold && (isFreeGiftHandle1InCart || isFreeGiftHandle2InCart)) {
                let handleToRemove = isFreeGiftHandle1InCart ? freeGiftHandle1 : freeGiftHandle2;
                this.removeProductFromCartDrawerByHandle(handleToRemove).then(() => {
                    this.refreshCartUI();
                });
            }
        })
        .catch((error) => console.error('Failed to fetch cart:', error));
}

function addProductToCartDrawerByHandle(productHandle) {
    return fetch(`/products/${productHandle}.js`)
        .then((response) => response.json())
        .then((productData) => {
            const variantId = productData.variants[0].id;
            return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: [
                        {
                            id: variantId,
                            quantity: 1,
                        },
                    ],
                }),
            });
        });
}

function removeProductFromCartDrawerByHandle(productHandle) {
    fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
            const lineItem = cart.items.find((item) => item.handle === productHandle);
            if (!lineItem) {
                throw new Error('Product not found in cart');
            }

            const line = cart.items.indexOf(lineItem) + 1;
            if (line === 0) {
                throw new Error('Line item not found');
            }

            const body = JSON.stringify({
                line,
                quantity: 0,
                sections: this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname,
            });

            return fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: body,
            })
                .then((response) => response.json())
                .then(() => {
                    this.refreshCartUI();
                });
        })
        .catch((error) => console.error('Error removing product from cart:', error));
}

document.addEventListener('DOMContentLoaded', function () {
    const cartDrawerElement = document.querySelector('cart-drawer');
    document.body.addEventListener('click', function (e) {
        if (e.target.matches('#CartDrawer-Overlay')) {
            if (cartDrawerElement && cartDrawerElement.classList.contains('active')) {
                cartDrawerElement.classList.remove('active');
            }
        }
    });

    // Function to open cart drawer
    function openCartDrawer() {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && !cartDrawer.classList.contains('active')) {
            cartDrawer.classList.add('animate', 'active');
        }
    }

    // Function to safely remove is-empty class and open drawer (only when needed)
    function removeEmptyClassAndOpenDrawer() {
        const cartDrawer = document.querySelector('cart-drawer');
        const cartDrawerItems = document.querySelector('cart-drawer-items');

        if (cartDrawer) {
            // Only remove is-empty class if cart drawer currently has it (transitioning from empty to non-empty)
            const wasEmpty = cartDrawer.classList.contains('is-empty');

            if (wasEmpty) {
                // Remove is-empty class from cart drawer elements only when transitioning from empty
                cartDrawer.classList.remove('is-empty');
                if (cartDrawerItems && cartDrawerItems.classList.contains('is-empty')) {
                    cartDrawerItems.classList.remove('is-empty');
                }

                // Small delay to ensure class removal is processed before opening
                setTimeout(() => {
                    openCartDrawer();
                }, 50);
            } else {
                // Cart was already non-empty, just open it
                openCartDrawer();
            }
        }
    }

    // Function to verify cart has been updated and then open drawer
    function openCartDrawerAfterUpdate(retryCount = 0, maxRetries = 10) {
        fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
                // Wait for cart to have items and UI to be updated
                if (cart.item_count > 0) {
                    // Wait a bit more for UI to be fully rendered
                    setTimeout(() => {
                        removeEmptyClassAndOpenDrawer();
                    }, 200);
                } else if (retryCount < maxRetries) {
                    // Retry if cart is still empty (give it time to update)
                    setTimeout(() => {
                        openCartDrawerAfterUpdate(retryCount + 1, maxRetries);
                    }, 100);
                }
            })
            .catch((error) => {
                console.error('Error checking cart status:', error);
                // Open drawer anyway after a delay as fallback
                if (retryCount === 0) {
                    setTimeout(() => {
                        removeEmptyClassAndOpenDrawer();
                    }, 500);
                }
            });
    }

    // Subscribe to cart update events to open cart drawer
    // This handles product form additions and other cart updates
    if (typeof subscribe === 'function') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            // Only open cart drawer for product form additions, not internal cart operations
            if (event.source === 'product-form') {
                // Wait for cart UI to be refreshed before opening
                setTimeout(() => {
                    openCartDrawerAfterUpdate();
                }, 300);
            }
        });
    }

    // Listen for cartUpdated events (fired after UI refresh)
    document.addEventListener('cartUpdated', function () {
        // This event is fired after the cart UI is refreshed
        // Verify cart has items before removing empty class and opening
        fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
                if (cart.item_count > 0) {
                    setTimeout(() => {
                        removeEmptyClassAndOpenDrawer();
                    }, 100);
                }
            })
            .catch((error) => {
                console.error('Error checking cart for cartUpdated event:', error);
            });
    });
});

const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    let elements = node.querySelectorAll('.free-gift-card-wrapper span.price-item');
                    elements.forEach((element) => {
                        if (element.textContent.trim() === '$0' || element.textContent.trim() === '$0.00') {
                            element.textContent = 'Free';
                        }
                    });
                }
            });
        }
        if (mutation.type === 'characterData' && mutation.target.nodeType === Node.TEXT_NODE) {
            if (mutation.target.parentNode.matches('.free-gift-card-wrapper span.price-item')) {
                if (mutation.target.textContent.trim() === '$0' || mutation.target.textContent.trim() === '$0.00') {
                    mutation.target.textContent = 'Free';
                }
            }
        }
    });
});

observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
});
